import type { SelectInputOption } from '@/components/inputs/SelectInput';
import { RoleRestriction, RoleRestrictionLabels } from '../../enums';
import type { InviteUserSchema } from '../../models';
import type { Control } from 'react-hook-form';
import {
  FormSelectMultiInput,
  TextInput,
  SelectInput,
} from '@/components';

interface InviteUserTypeAndRolesCardProps {
  control: Control<InviteUserSchema>;
  lockedUserType: RoleRestriction;
  userType: string;
  isSingleRoleUser: boolean;
  rolesOptions: SelectInputOption[];
  isLoadingOptions: boolean;
  roleIds: string[];
  onRoleChange: (value: string) => void;
  roleError?: string;
}

const InviteUserTypeAndRolesCard = ({
  control,
  lockedUserType,
  userType,
  isSingleRoleUser,
  rolesOptions,
  isLoadingOptions,
  roleIds,
  onRoleChange,
  roleError,
}: InviteUserTypeAndRolesCardProps) => (
  <div className='bg-white rounded-lg p-6 border border-gray-200 shadow-sm'>
    <h3 className='text-lg font-semibold text-gray-800 mb-4'>
      Tipo de usuario y Roles
    </h3>
    <div className='flex flex-col gap-4'>
      <div className='flex gap-4'>
        <div className='flex-1 min-w-0 overflow-hidden pt-2'>
          <TextInput
            name='userTypeReadOnly'
            placeholder='Tipo de usuario'
            value={RoleRestrictionLabels[lockedUserType]}
            onChange={() => {}}
            disabled
          />
        </div>
        <div className='flex-1 min-w-0 overflow-hidden pt-2'>
          {isSingleRoleUser ? (
            <SelectInput
              name='roleIds'
              placeholder={
                isLoadingOptions ? 'Cargando roles...' : 'Seleccionar rol'
              }
              options={rolesOptions}
              value={roleIds[0] ?? ''}
              onChange={onRoleChange}
              required
              disabled={!userType}
              error={!!roleError}
              errorInfo={roleError}
            />
          ) : (
            <FormSelectMultiInput
              name='roleIds'
              control={control}
              placeholder={
                isLoadingOptions ? 'Cargando roles...' : 'Seleccionar roles'
              }
              options={rolesOptions}
              disabled={!userType}
            />
          )}
        </div>
      </div>
    </div>
  </div>
);

export default InviteUserTypeAndRolesCard;
